import * as THREE from 'three';
import {Camera, Object3D, PerspectiveCamera, Spherical, Vector3} from 'three';
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {Control} from "./panda";
import * as TWEEN from '@tweenjs/tween.js';

class EditorControls {
  dom:HTMLElement;

  camera:Camera;
  controls: OrbitControls;

  private delta = new THREE.Vector3();
  private box = new THREE.Box3();
  private center = new THREE.Vector3();
  private sphere = new THREE.Sphere();

  constructor( camera:Camera, domElement:HTMLElement  ) {
    this.camera=camera;
    this.dom=domElement;
    this.controls = new OrbitControls( this.camera, this.dom );
    this.controls.minPolarAngle = Math.PI / 4
    this.controls.maxPolarAngle = (Math.PI / 2) * 0.96
    this.controls.update()

  }
  // 聚焦
  focus(targetModel) {
    let distance;

    this.box.setFromObject( targetModel );

    if ( this.box.isEmpty() === false ) {
      this.box.getCenter( this.center );
      distance = this.box.getBoundingSphere( this.sphere ).radius;
    } else {
      this.center.setFromMatrixPosition( targetModel.matrixWorld );
      distance = 0.1;
    }

    this.delta.set( 0, 0, 1 );
    this.delta.applyQuaternion( this.camera.quaternion );
    this.delta.multiplyScalar( distance * 4 );

    this.camera.position.copy( this.center ).add( this.delta );

    this.controls.target.copy(targetModel.position);
    this.controls.update();
  }
  // 动画聚焦到物体
  createCameraTween(focusTime, targetModel) {
    let that = this

    let distance;
    const pos = new THREE.Vector3();
    targetModel.getWorldPosition(pos); //获取三维场景中某个对象世界坐标
    // 相机飞行到的位置和观察目标拉开一定的距离
    this.box.setFromObject( targetModel );
    if ( this.box.isEmpty() === false ) {
      this.box.getCenter( this.center );
      distance = this.box.getBoundingSphere( this.sphere ).radius;
    } else {
      this.center.setFromMatrixPosition( targetModel.matrixWorld );
      distance = 0.1;
    }
    const pos2 = pos.clone().addScalar(distance * 4);

    new TWEEN.Tween({
      // 不管相机此刻处于什么状态，直接读取当前的位置和目标观察点
      x: this.camera.position.x,
      y: this.camera.position.y,
      z: this.camera.position.z,
      tx: this.controls.target.x,
      ty: this.controls.target.y,
      tz: this.controls.target.z,
    })
        .to({
          // 动画结束相机位置坐标
          x: pos2.x,
          y: pos2.y,
          z: pos2.z,
          // 动画结束相机指向的目标观察点
          tx: targetModel.x,
          ty: targetModel.y,
          tz: targetModel.z,
        }, focusTime)
        .onUpdate(function (obj) {
          // 动态改变相机位置
          that.camera.position.set(obj.x, obj.y, obj.z);
          // 动态计算相机视线
          that.controls.target.set(obj.tx, obj.ty, obj.tz);
          that.controls.update();//内部会执行.lookAt()
        })
        .start();
  }

  setOptions(params:Control){
    if (params === undefined)
      return
    if(params.autoRotate!==undefined){
      this.controls.autoRotate=params.autoRotate;
    }
    if(params.autoRotateSpeed!==undefined){
      this.controls.autoRotateSpeed=params.autoRotateSpeed;
    }
    if(params.dampingFactor!==undefined){
      this.controls.dampingFactor=params.dampingFactor;
    }
    if(params.enableDamping!==undefined){
      this.controls.enableDamping=params.enableDamping;
    }
    if(params.enablePan!==undefined){
      this.controls.enablePan=params.enablePan;
    }
    if(params.enableRotate!==undefined){
      this.controls.enableRotate=params.enableRotate;
    }
    if(params.enableZoom!==undefined){
      this.controls.enableZoom=params.enableZoom;
    }
    if(params.keyPanSpeed!==undefined){
      this.controls.keyPanSpeed=params.keyPanSpeed;
    }
    if(params.maxAzimuthAngle!==undefined){
      this.controls.maxAzimuthAngle=params.maxAzimuthAngle;
    }
    if(params.maxDistance!==undefined){
      this.controls.maxDistance=params.maxDistance;
    }
    if(params.maxPolarAngle!==undefined){
      this.controls.maxPolarAngle=params.maxPolarAngle;
    }
    if(params.maxZoom!==undefined){
      this.controls.maxZoom=params.maxZoom;
    }
    if(params.minAzimuthAngle!==undefined){
      this.controls.minAzimuthAngle=params.minAzimuthAngle;
    }
    if(params.minDistance!==undefined){
      this.controls.minDistance=params.minDistance;
    }
    if(params.minPolarAngle!==undefined){
      this.controls.minPolarAngle=params.minPolarAngle;
    }
    if(params.minZoom!==undefined){
      this.controls.minZoom=params.minZoom;
    }
    if(params.panSpeed!==undefined){
      this.controls.panSpeed=params.panSpeed;
    }
    if(params.rotateSpeed!==undefined){
      this.controls.rotateSpeed=params.rotateSpeed;
    }
    if(params.screenSpacePanning!==undefined){
      this.controls.screenSpacePanning=params.screenSpacePanning;
    }
    if(params.zoomSpeed!==undefined){
      this.controls.zoomSpeed=params.zoomSpeed;
    }
    if(params.zoomToCursor!==undefined){
      this.controls.zoomToCursor=params.zoomToCursor;
    }
  }

}

export { EditorControls };
